export const AFOSTO_GQL_ENDPOINT = 'https://afosto.app/graphql';
